var React = require('react');

function SocialTwitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 5.255a9.09 9.09 0 01-2.71.752 4.798 4.798 0 002.072-2.653c-.913.553-1.92.95-2.992 1.164A4.695 4.695 0 0016.928 3c-3.044 0-5.283 2.89-4.595 5.889-3.92-.2-7.398-2.108-9.724-5.012-1.232 2.152-.638 4.975 1.456 6.405a4.672 4.672 0 01-2.137-.597c-.051 2.225 1.514 4.304 3.782 4.76a4.595 4.595 0 01-2.13.082c.601 1.909 2.34 3.294 4.406 3.331A9.414 9.414 0 011 19.848 13.163 13.163 0 008.232 22c8.754 0 13.703-7.525 13.406-14.268A9.294 9.294 0 0024 5.255z"}));
}

SocialTwitter.defaultProps = {"viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = SocialTwitter;

SocialTwitter.default = SocialTwitter;
